<template>
    <modal title="Routes" width="45" class="sm:62" :showModal="showModal" @close-modal="closeModal">
        <div class="w-full">
            <div class="option_table" v-for="(opt) in activeOptions" :key="'opt' + opt.id"
                @click="removeActive(opt.id)">
                <img class="w-5" src="@/assets/images/icons/addSort.svg" />
                <span>
                    {{ opt.name || '' }}
                </span>
                <Eye :color="opt.active ? '#FCC210' : '#878E99'" />
            </div>
            <hr class="liner" />

            <div class="option_table" v-for="(opt) in inactiveOptions" :key="'opt' + opt.id"
                @click="addToActive(opt.id)">
                <img class="w-5" src="@/assets/images/icons/addSort.svg" />
                <span>
                    {{ opt.name || '' }}
                </span>
                <Eye :color="opt.active ? '#FCC210' : '#878E99'" />
            </div>
        </div>
    </modal>
</template>

<script>
import Eye from "@/assets/images/icons/Eye.vue"


export default {
    components: { Eye },
    props: {
        showModal: Boolean,
        setOptions: { type: Function }
    },
    data() {
        return {
            options: [
                { name: 'Terminal Name', id: 'TerminalName', active: true },
                { name: 'Terminal ID', id: 'TerminalCode', active: true },
                { name: 'Address', id: 'Address', active: true },
                { name: 'City', id: 'City', active: true },
                { name: 'Country', id: 'Country', active: false },
                { name: 'Zip Code', id: 'ZipCode', active: false },
                { name: 'Date Created', id: 'DateCreated', active: false },
                { name: 'Terminal ID', id: 'TerminalID', active: false },
                { name: 'Terminal manager', id: 'TerminalManager', active: true }
            ]
        }
    },
    computed: {
        activeOptions() {
            return this.options.filter(item => item.active)
        },
        inactiveOptions() {
            return this.options.filter(item => !item.active)
        }
    },
    watch: {
        options: {
            deep: true,
            immediate: true,
            handler() {
                this.setOptions(this.activeOptions)
            }
        }
    },
    mounted() {
        this.setOptions(this.activeOptions)
    },
    methods: {
        removeActive(val) {
            if (this.activeOptions.length < 4) return
            let opts = this.options
            let findItemIndex = opts.findIndex((item) => item.id == val)
            opts[findItemIndex].active = false
            this.options = opts
        },
        addToActive(val) {
            let opts = this.options
            let findItemIndex = opts.findIndex((item) => item.id == val)
            opts[findItemIndex].active = true
            this.options = opts
        },
        closeModal() {
            this.$emit("close-modal");
        },
    }
};
</script>

<style scoped>
.option_table {
    @apply py-3 px-4 flex items-center my-3 w-full;

    span {
        @apply px-4 w-full cursor-pointer
    }
}

.liner {
    @apply h-[2px] border-none bg-gray-300 w-full my-2
}
</style>